function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.2631 9.42287C16.708 9.14206 17.0495 8.69681 17.2097 8.1664C16.7931 8.42705 16.3327 8.61556 15.8415 8.71761C15.4496 8.2756 14.8893 8 14.2693 8C13.0799 8 12.116 9.01726 12.116 10.2718C12.116 10.4499 12.1338 10.6234 12.1708 10.7892C10.3811 10.6943 8.79407 9.79077 7.73094 8.41535C7.54543 8.75206 7.43943 9.14206 7.43943 9.55807C7.43943 10.3459 7.81969 11.0414 8.39778 11.4496C8.04464 11.4379 7.71245 11.3345 7.42155 11.1655V11.1935C7.42155 12.2946 8.16359 13.2131 9.15029 13.4211C8.9691 13.4744 8.77927 13.501 8.58206 13.501C8.44339 13.501 8.3078 13.4874 8.17714 13.4607C8.45078 14.3629 9.24643 15.0207 10.1894 15.0383C9.45166 15.648 8.52289 16.0107 7.514 16.0107C7.3402 16.0107 7.16825 16.0009 7 15.9795C7.95342 16.6236 9.08558 17 10.3022 17C14.265 17 16.4307 13.5381 16.4307 10.5357C16.4307 10.4369 16.4295 10.3387 16.4252 10.2419C16.8461 9.92142 17.2122 9.52102 17.5 9.06536C17.1136 9.24606 16.6982 9.36827 16.2631 9.42287Z"
});

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.7eaf13b4.svg";
export { ForwardRef as ReactComponent };